import { useState } from "react";
import { TENANT_DOMAIN } from "../../../utils/domain";
import { ERROR_MESSAGES } from "../../../constant/constant";
import { useAxios } from "../../../utils/useAxios";

/**
 * @typedef {object} QuestResponseItem
 * @property {number} id
 * @property {number} category_id
 * @property {string} title
 * @property {string} description
 * @property {string} thumbnail
 * @property {string|null} certificateLogo
 * @property {string|null} trailerType
 * @property {string|null} trailerHin
 * @property {string|null} trailerEng
 * @property {string|null} trailerHinJwp
 * @property {string|null} trailerEngJwp
 * @property {string|number|null} totalChapters
 * @property {string} createdBY
 * @property {string} type
 * @property {string|number} status
 * @property {string} created_at
 * @property {string} updated_at
 * @property {string} thumbnail_url
 * @property {boolean} student_assigned
 * @property {number|null} school_id
 */

/**
 * Hook to fetch Student Quests
 * @returns {{
 *  quests: QuestResponseItem[],
 *  loading: boolean,
 *  error: string,
 *  getQuests: () => Promise<void>
 * }}
 */
export const useGetQuests = () => {
  const [quests, setQuests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const { axiosInstance } = useAxios();

  const getQuests = async (type = "quest") => {
    try {
      setLoading(true);
      setError("");

      const response = await axiosInstance.get(
        `${TENANT_DOMAIN}/student/quests-map`,
        {
          params: { type },
        }
      );

      setQuests(response?.data?.data || []);
    } catch (err) {
      setQuests([]);
      if (err?.response?.status === 500) {
        setError(ERROR_MESSAGES.INTERNAL_SERVER);
      } else {
        setError(err?.response?.data?.message || ERROR_MESSAGES.UNKNOWN);
      }
    } finally {
      setLoading(false);
    }
  };

  return { quests, loading, error, getQuests };
};
